import { Card } from '../../../../../components/card/card';
import { EditableField } from '../../../../../components/field/field';
import { Typography } from '../../../../../components/typography/typography';
import { toast } from '../../../../../util/toasts';

export const DiscountDetails = ({
  name,
  discount,
  setName,
  setDiscount,
  onNameBlur,
  save,
  isSaving,
}: {
  name: string;
  discount: number;
  setName: (name: string) => void;
  setDiscount: (discount: number) => void;
  onNameBlur: () => void;
  save: (values?: { name?: string; discount?: number }) => void;
  isSaving: boolean;
}) => {
  return (
    <Card className="card gap-4">
      <Typography type="text-xl" weight="semi-bold">
        Discount Details
      </Typography>
      <Typography type="text-md" weight="regular" className="text-grey-500">
        Define the name and percentage applied for this discount.{' '}
      </Typography>
      <>
        <Typography className="flex flex-row items-center" type="text-md" weight="regular">
          Discount name <p className="required"> *</p>
        </Typography>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          onBlur={onNameBlur}
          className="w-full md:max-w-[40vw]"
          disabled={isSaving}
          data-cy="discount-name"
        />
      </>
      <>
        <Typography className="flex flex-row items-center" type="text-md" weight="regular">
          Discount percentage <p className="required"> *</p>
        </Typography>
        <EditableField
          type="number"
          value={discount}
          formattedValue={`% ${discount}`}
          onChange={(value) => {
            if (value < 0 || value > 100) {
              toast('Discount must be between 0% and 100%', 'error');
              return;
            }

            setDiscount(value);
            save({ discount: value });
          }}
        />
      </>
    </Card>
  );
};
